module.exports = __webpack_public_path__ + "img/attendance_4.339b95b2.png";